module.exports = __webpack_public_path__ + "img/loading.7615e37d.svg";